import { useState } from 'react';
import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import { useId } from '../../page-framework/panel/Panel';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import SiteStatusBreakout from './SiteStatusBreakout';
import SummaryAndMap from './SummaryAndMap';
import { useTimeRangeSelection } from '../../charts/status-breakout/UseTimeRangeSelection';
import { MAP_PANEL_PREVIEW_IMAGE, PANEL_CATEGORIES, PANEL_PRIORITIES } from '../../page-framework/panel/PanelRegistry';
import { siteGroupFilterId, businessServiceGroupFilterId, statusFilterId, timeRangeFilterId } from '../../filters';
import { MapPanelLoadingProvider } from './MapPanelLoadingContext';

const title = t`Sites Overview`;

function MapPanel() {
    const id = useId();
    const [timeRangeSelection, setTimeRangeSelection] = useState();
    const mapFilterState = useTimeRangeSelection(timeRangeSelection);

    return (
        <div className="flex-container">
            <MapPanelLoadingProvider>
                <SiteStatusBreakout onTimeRangeChange={setTimeRangeSelection} />
                <SummaryAndMap id={id} filterState={mapFilterState} storageKey={id} />
            </MapPanelLoadingProvider>
        </div>
    );
}

MapPanel.propTypes = panelPropTypes;

MapPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 600,
    minContentHeight: 300,
};

export default Panel({
    typeAlias: 'StatusMap',
    catalogEntry: {
        category: PANEL_CATEGORIES.SITE,
        priority: PANEL_PRIORITIES.OVERVIEW,
        title,
        description: t`Overview of sites status shown on a map`,
        previewImage: MAP_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeFilterId],
        optional: [statusFilterId, siteGroupFilterId, businessServiceGroupFilterId],
    },
})(MapPanel);
